import React, { useState, useEffect } from 'react';
import './HeroSlider.css';

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Slider data with different backgrounds and content
  const slides = [
    {
      id: 1,
      title: "Executive Search & Tech Recruitment",
      subtitle: "Connecting Talent with Opportunity",
      description: "From C-level leaders to tech innovators, we find the right talent for your business success.",
      background: "#ffffff",
      textColor: "black"
    },
    {
      id: 2,
      title: "Blue Collar & Manpower Supply",
      subtitle: "Workforce That Builds the Future",
      description: "Supplying skilled & unskilled labor globally with compliance, reliability, and efficiency.",
      background: "#000000",
      textColor: "white"
    },
    {
      id: 3,
      title: "Payroll & HR Outsourcing",
      subtitle: "Simplify HR. Amplify Growth.",
      description: "Manage payroll & HR with our AI-powered Cloud HRMS.",
      background: "#ffffff",
      textColor: "black"
    },
    {
      id: 4,
      title: "Sustainability & Impact",
      subtitle: "HR with Purpose",
      description: "Driving digital education, women empowerment, and 10M global jobs for a better tomorrow.",
      background: "#000000",
      textColor: "white"
    }
  ];

  // Auto-slide functionality
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-slider">
      <div className="slider-container">
        {/* Slider slides */}
        <div className="slides-wrapper">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`slide ${index === currentSlide ? 'active' : ''}`}
              style={{ background: slide.background }}
            >
              <div className="slide-overlay">
                <div className="slide-content" style={{ color: slide.textColor }}>
                  <h1 className="slide-title" style={{ color: slide.textColor }}>
                    {slide.title}
                  </h1>
                  <h2 className="slide-headline" style={{ color: slide.textColor }}>
                    {slide.subtitle}
                  </h2>
                  {slide.description && (
                    <p className="slide-subtitle" style={{ color: slide.textColor }}>
                      {slide.description}
                    </p>
                  )}
                  <div className="slide-buttons">
                    <button 
                      className={`btn ${slide.textColor === 'black' ? 'btn-primary' : 'btn-secondary'}`}
                      onClick={() => scrollToSection('services')}
                    >
                      Our Services
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation arrows */}
        <button className="slider-nav prev" onClick={prevSlide}>
          <i className="fas fa-chevron-left"></i>
        </button>
        <button className="slider-nav next" onClick={nextSlide}>
          <i className="fas fa-chevron-right"></i>
        </button>

        {/* Dots indicator */}
        <div className="slider-dots" style={{ 
          '--dot-color': slides[currentSlide].background === '#ffffff' ? '#000' : '#fff',
          '--dot-border': slides[currentSlide].background === '#ffffff' ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255, 255, 255, 0.5)',
          '--dot-active': slides[currentSlide].background === '#ffffff' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)',
          '--dot-hover': slides[currentSlide].background === '#ffffff' ? 'rgba(0, 0, 0, 0.6)' : 'rgba(255, 255, 255, 0.6)'
        }}>
          {slides.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSlider;
